import {
    GETKYCCONFIGURATIONDETAILS_SUCCESS,
    GETKYCCONFIGURATIONDETAILS_FAILED,
    RESET_GETKYCCONFIGURATIONDETAILS,
    LOADING_GETKYCCONFIGURATIONDETAILS,
    NETWORK_ERROR_GETKYCCONFIGURATIONDETAILS
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETKYCCONFIGURATIONDETAILS:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case GETKYCCONFIGURATIONDETAILS_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case GETKYCCONFIGURATIONDETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_GETKYCCONFIGURATIONDETAILS:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_GETKYCCONFIGURATIONDETAILS:
            return (state = initialState);
        default:
            return state;
    }
};
